export default "__VITE_ASSET__2e1547ea__"